import React from "react";
import { Row, Col, Table } from "react-bootstrap";
import { CommonModal, CommonButton } from "../Input";

const TopUpWithdrawDetailsModal = ({ show, onHide, transaction }) => {
  if (!transaction) return null;

  const isWithdraw = transaction.type === "Withdraw";

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title={`${isWithdraw ? "Withdrawal" : "Top-up"} Transaction Details`}
      fullscreen={true}
      headerClassName="px-4 py-3"
      footer={
        <div className="d-flex justify-content-end w-100 px-3">
          <CommonButton
            variant="outline"
            className="px-5"
            onClick={onHide}
            style={{ borderColor: "#E2E8F0" }}
          >
            Close
          </CommonButton>
        </div>
      }
    >
      <div className="px-4 pt-2">
        {/* Top Actions */}
        <div className="d-flex justify-content-end gap-2 mb-4">
          <CommonButton variant="outline" className="d-flex align-items-center gap-2 py-1 px-3">
            <i className="fa fa-download fs-12"></i> <span className="fs-12">Download</span>
          </CommonButton>
          <CommonButton variant="outline" className="d-flex align-items-center gap-2 py-1 px-3">
            <i className="fa fa-print fs-12"></i> <span className="fs-12">Print</span>
          </CommonButton>
          <CommonButton variant="outline" className="d-flex align-items-center gap-2 py-1 px-3">
            <i className="far fa-envelope fs-12"></i> <span className="fs-12">Email</span>
          </CommonButton>
        </div>

        {/* Transaction Information */}
        <div className="mb-4">
          <label className="text-black fw-bold fs-12 mb-3">Transaction Information</label>
          <div className="bg-white rounded-4 p-4 border border-light shadow-none">
            <Row>
              <Col md={4}>
                <div className="text-muted fs-11 mb-2">Transaction ID</div>
                <div className="fw-bold text-black fs-13">{transaction.id}</div>
              </Col>
              <Col md={4}>
                <div className="text-muted fs-11 mb-2">Created Date</div>
                <div className="fw-bold text-black fs-13">{transaction.displayDate}</div>
              </Col>
              <Col md={4}>
                <div className="text-muted fs-11 mb-2">Teller</div>
                <div className="fw-bold text-black fs-13">teller (ID: 64)</div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Customer Information */}
        <div className="mb-4">
          <label className="text-black fw-bold fs-12 mb-3">Customer Information</label>
          <div className="bg-white rounded-4 p-4 border border-light shadow-none">
            <Row className="mb-4">
              <Col md={4}>
                <div className="text-muted fs-11 mb-2">Customer name</div>
                <div className="fw-bold text-black fs-13">{transaction.customerName}</div>
              </Col>
              <Col md={4}>
                <div className="text-muted fs-11 mb-2">Phone</div>
                <div className="fw-bold text-black fs-13">Not provided</div>
              </Col>
              <Col md={4}>
                <div className="text-muted fs-11 mb-2">Email</div>
                <div className="fw-bold text-black fs-13">{transaction.customerEmail}</div>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <div className="text-muted fs-11 mb-2">Wallet Balance Before</div>
                <div className="fw-bold text-black fs-13">111,719 SGD</div>
              </Col>
              <Col md={4}>
                <div className="text-muted fs-11 mb-2">Wallet Balance After</div>
                <div className="fw-bold text-black fs-13">111,612.45 SGD</div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Amount Details */}
        <div className="mb-4">
          <label className="text-black fw-bold fs-12 mb-3">Amount Details</label>
          <div className="bg-white rounded-4 overflow-hidden border border-light shadow-none">
            <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
              <span className="text-muted fs-13">{isWithdraw ? "Withdrawal" : "Top-up"} Amount</span>
              <span className="fw-bold text-black fs-14">{transaction.amount}</span>
            </div>
            <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
              <span className="text-muted fs-13">Transaction Fee</span>
              <span className="fw-bold text-black fs-14">{transaction.fee}</span>
            </div>
            <div className="p-3 d-flex justify-content-between align-items-center bg-light bg-opacity-10">
              <span className="text-black fw-bold fs-14">Total {isWithdraw ? "Deducted" : "Added"}</span>
              <span className="text-black fw-bold fs-16">106.55 SGD</span>
            </div>
          </div>
        </div>

        {/* Cash Denomination Breakdown */}
        <div className="mb-5">
          <label className="text-black fw-bold fs-12 mb-3">Cash Denomination Breakdown</label>
          <div className="card border-0 shadow-none rounded-4 overflow-hidden border border-light">
            <Table responsive className="mb-0 custom-table-style fs-12">
              <thead className="bg-light">
                <tr>
                  <th className="ps-4" style={{ width: "80px" }}>No</th>
                  <th>Denomination</th>
                  <th className="text-center">Quantity</th>
                  <th className="pe-4 text-end">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="ps-4">1</td>
                  <td className="fw-bold">100 Dollars</td>
                  <td className="text-center">1</td>
                  <td className="pe-4 text-end fw-bold">{transaction.amount}</td>
                </tr>
                <tr className="bg-light bg-opacity-25">
                  <td colSpan={2} className="ps-4 fw-bold">Total Cash {isWithdraw ? "Dispensed" : "Received"}</td>
                  <td className="text-center fw-bold">1 Notes</td>
                  <td className="pe-4 text-end fw-bold">{transaction.amount}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

export default TopUpWithdrawDetailsModal;
